import { TableContainer } from 'ui/StyledComponents/Tables'
import { useIntl } from 'react-intl'
import {
	TableRow,
	TableColumn,
	DataTable,
	TableHeader,
	TableBody,
	ListItem,
	FontIcon,
} from 'react-md'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { discountGroupHeaders } from './constants'
import LoadingState from 'ui/components/LoadingState'
import { LoadingContainer } from '../../components'
import DiscountGroupRow from './DiscountGroupRow'
import type { DiscountGroup } from './types'

type DiscountGroupTableProps = {
	discountGroups: DiscountGroup[]
	loading: boolean
}

const DiscountGroupTable = ({
	discountGroups,
	loading,
}: DiscountGroupTableProps) => {
	const intl = useIntl()
	const dispatch = useDispatch()

	const [processing, setProcessing] = useState<boolean>(false)

	const renderTableHeaders = () => {
		return (
			<TableRow>
				{discountGroupHeaders
					.filter((h) => h.show)
					.map((header) => (
						//@ts-ignore //TODO: REMOVE
						<TableColumn key={header.key}>
							<p className="text-strong text-subtle">{header.title(intl)}</p>
						</TableColumn>
					))}
				<TableColumn key={'children-header'}></TableColumn>
			</TableRow>
		)
	}

	const handleOnClick = (uuid: string) => {
		setProcessing(false) //TODO: REMOVE
		dispatch(
			push(window.location.pathname + window.location.hash + '?uuid=' + uuid),
		)
	}

	return (
		<TableContainer>
			{loading && (
				<LoadingContainer>
					<LoadingState />
				</LoadingContainer>
			)}
			{discountGroups ? (
				<DataTable
					plain
					style={{
						background: 'white',
						maxHeight: 'calc(100vh - 205px)',
					}}
				>
					<TableHeader
						style={{
							position: 'sticky',
							top: 0,
							zIndex: 1,
							background: 'white',
						}}
					>
						{renderTableHeaders()}
					</TableHeader>
					<TableBody>
						{discountGroups
							.map((discountGroup) => (
								<DiscountGroupRow
									key={discountGroup.uuid}
									discountGroup={discountGroup}
									menuItems={[
										<ListItem
											key={1}
											primaryText={intl.formatMessage({
												defaultMessage: 'Poista',
												description: 'Delete',
											})}
											leftIcon={<FontIcon>delete</FontIcon>}
											onClick={() => {}}
											className="md-divider-border md-divider-border--right"
										/>,
									]}
									children={null}
									processing={processing}
									handleOnClick={() => handleOnClick(discountGroup.uuid)}
								/>
							))
							.concat(
								<tr
									key="empty-row"
									className="full-width"
									style={{ height: 100 }}
								></tr>,
							)}
					</TableBody>
				</DataTable>
			) : null}
		</TableContainer>
	)
}

export default DiscountGroupTable
